import { keepPreviousData, useQuery } from "@tanstack/react-query";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link, useParams } from "react-router-dom";
import qs from "qs";

import {
  addUserPersonalizedSampleProducts,
  getSampleProducts,
} from "./sample-products-section.service";
import Sidebar from "../../sidebar";
import toast from "react-hot-toast";

export default function SampleProductsSection() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageParam = queryParams.get("page");
  const [currentPage, setCurrentPage] = useState(
    pageParam ? parseInt(pageParam) : 1
  );
  const params = useParams();
  const [products, setProducts] = useState<any>([]);

  // Search-related states
  const [name, setName] = useState("");
  const [dimension, setDimension] = useState("");
  const [side, setSide] = useState("");
  const [value, setValue] = useState("");

  console.log("params", params);
  console.log("products", products);
  console.log("currentPage", currentPage);
  console.log("name", name);
  console.log("dimension", dimension);
  console.log("side", side);
  console.log("value", value);
  console.log("location", location);

  useEffect(() => {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (params.name) setName(params.name as string);
    if (params.dimension) setDimension(params.dimension as string);
    if (params.side) setSide(params.side as string);
    if (params.value) setValue(params.value as string);
    if (params.page) setCurrentPage(parseInt(params.page as string));
  }, [location.search]);

  const handleFilter = () => {
    if (!dimension || !side || !value) return;
    const query = qs.stringify(
      { name, dimension, side, value, page: currentPage },
      { addQueryPrefix: true }
    );
    navigate(`/admin/personalized-users/${params.user}/products${query}`);
  };

  const handleClear = () => {
    setName("");
    setDimension("");
    setSide("");
    setValue("");
    navigate(
      `/admin/personalized-users/${params.user}/products?page=${currentPage}`
    );
  };

  const handleName = (e: any) => {
    setName(e.target.value);
    const query = qs.stringify(
      { name: e.target.value, dimension, side, value, page: currentPage },
      { addQueryPrefix: true }
    );
    navigate(`/admin/personalized-users/${params.user}/products${query}`);
  };

  const {
    isPending,
    isError,
    data: response,
    error,
  } = useQuery({
    queryKey: [
      "admin-personalized-sample-products",
      currentPage,
      name,
      dimension,
      side,
      value,
    ],
    queryFn: () =>
      getSampleProducts({
        page: currentPage,
        limit: 500,
        name,
        dimension,
        side,
        value,
      }),
    placeholderData: keepPreviousData,
  });

  const handlePageChange = (selectedItem: { selected: number }) => {
    const newPage = selectedItem.selected + 1;
    setCurrentPage(newPage);
    const query = qs.stringify(
      { name, dimension, side, value, page: newPage },
      { addQueryPrefix: true }
    );
    navigate(`/admin/personalized-users/${params.user}/products/${query}`);
  };

  const handleSubmit = () => {
    const expire = localStorage.getItem("expireDate");
    const uuid = localStorage.getItem("uuid");
    const value = {
      userId: params.user,
      products: products,
      expireDate: expire,
      uuid: uuid,
    };

    addUserPersonalizedSampleProducts(value)
      .then((res) => {
        navigate("/admin/personalized-users");
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  };

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Sample Products</h5>
                <div className="ec-header-btn">
                  <div
                    className="btn btn-lg btn-primary"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Submit
                  </div>
                </div>
              </div>
              <div className="ec-vendor-card-body">
                {/* Search and Filter Section */}
                <div className="ec-pro-list-top d-flex row mb-3">
                  <div className="col-md-3 ec-grid-list">
                    <div className="ec-input-inner">
                      <input
                        type="text"
                        placeholder="Search"
                        className="ec-input"
                        name="name"
                        style={{
                          background: "white",
                          border: "0",
                          height: "34px",
                        }}
                        value={name}
                        onChange={handleName}
                      />
                    </div>
                  </div>

                  <div className="col-md-9 ec-sort-select">
                    <div className="ec-select-inner mr-1">
                      <select
                        name="dimension-select"
                        id="dimension-select"
                        value={dimension}
                        onChange={(e) => setDimension(e.target.value)}
                      >
                        <option value="" disabled>
                          Dimension
                        </option>
                        <option value="inch">Inch</option>
                        <option value="cm">CM</option>
                      </select>
                    </div>
                    <div className="ec-select-inner mr-1">
                      <select
                        name="side-select"
                        id="side-select"
                        value={side}
                        onChange={(e) => setSide(e.target.value)}
                      >
                        <option value="" disabled>
                          Side
                        </option>
                        <option value="length">Length</option>
                        <option value="width">Width</option>
                        <option value="height">Height</option>
                      </select>
                    </div>
                    <div className="ec-input-inner mr-1">
                      <input
                        type="text"
                        placeholder="Value"
                        className="ec-input"
                        name="value"
                        style={{
                          background: "white",
                          border: "0",
                          height: "34px",
                        }}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                      />
                    </div>
                    <button className="btn btn-list" onClick={handleFilter}>
                      Filter
                    </button>
                    <button
                      className="btn btn-grid active"
                      onClick={handleClear}
                    >
                      Clear
                    </button>
                  </div>
                </div>

                <div className="ec-vendor-card-table">
                  <table className="table ec-table">
                    <thead>
                      <tr>
                        <th></th>
                        <th scope="col">Image</th>
                        <th scope="col">Product Code</th>
                        <th scope="col">Product Name</th>
                        <th scope="col">Category</th>
                      </tr>
                    </thead>
                    <tbody>
                      {response?.data.results.map((product: any) => (
                        <tr key={product.id}>
                          <td>
                            <input
                              className=""
                              type="checkbox"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setProducts([
                                    ...products,
                                    {
                                      productId: product.id,
                                      categoryId: product.categoryId,
                                    },
                                  ]);
                                } else {
                                  setProducts(
                                    products.filter(
                                      (item: any) =>
                                        item.productId !== product.id
                                    )
                                  );
                                }
                              }}
                            />
                          </td>
                          <td>
                            {product.image ? (
                              <img
                                src={`https://d1gdand68muq63.cloudfront.net/sample-products/96/${product.image.key}`}
                                alt={product.name}
                                width="80"
                              />
                            ) : (
                              <span>No Image Available</span>
                            )}
                          </td>
                          <td>
                            <span>{product.code}</span>
                          </td>
                          <td>
                            <span>{product.name}</span>
                          </td>
                          <td>
                            <span>{product.category}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="col-lg-12">
                  <ReactPaginate
                    nextLabel=">>"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={response?.data.totalPages}
                    forcePage={currentPage - 1}
                    previousLabel="<<"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
